import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "antd-tabs" }
const _hoisted_2 = { class: "antd-tabs-nav" }
const _hoisted_3 = ["onClick"]




export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: null,
    options: null
  },
  emits: ["update:modelValue"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
        return (_openBlock(), _createElementBlock("button", {
          type: "button",
          class: _normalizeClass(["antd-tab", { 'antd-tab--active': __props.modelValue === option }]),
          key: option,
          onClick: _withModifiers(($event: any) => (_ctx.$emit('update:modelValue', option)), ["prevent"])
        }, _toDisplayString(option), 11, _hoisted_3))
      }), 128))
    ])
  ]))
}
}

})